import Card from '../../../components/Card/Card.vue';
import GenericTable from '../../../components/GenericTable/GenericTable.vue';
import Vue from 'vue';
export default Vue.extend({
    components: { Card, GenericTable },
    props: {
        labelProp: { type: String, default: 'label', required: true },
        classProp: { type: Object, default: () => ({}), required: true }
    },
    data() {
        return {
            visible: false
        };
    },
    computed: {
        tableProps() {
            return {
                style: 'position:relative;top:-30px',
                localEntityNameProp: 'ci.reservations',
                startingFilterModelProp: [
                    { field: 'class_id', predicate: 'equals', value: this.classProp.id }
                ],
                injectIntoLocalFilterModelProp: [{ field: 'class_id', predicate: 'containedIn', value: this.classProp.id }],
                fetchIntoLocalDataInsteadOfStore: true,
                initialRowsPerPageProp: 100
            };
        }
    }
});
